import { Fragment, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./video-ai.css";
import axios from "axios";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import swal from "sweetalert";
import InfoIcon from "@mui/icons-material/Info";
import { IconButton } from "@material-ui/core";
import SampleVideoModal from "../../Components_V2/VideoAi/SampleVideoModal";
import SampleTextVideo from "../../Components_V2/AIVideoSample/TextVideo";
import useUniqueNews from "../VideoAiNews/News";
import CreditsButton_V2 from "../../Components_V2/CreditsButton/CreditsButton";
import PageHeading_V2 from "../../Components_V2/PageHeading/PageHeading";

const VideoAiNews_V2 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { uniqueNews, uniqueNewsByCategory } = useUniqueNews();
  const [randomQuestion, setRandomQuestion] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [query, setQuery] = useState("");
  const [event, setEvent] = useState("Day");
  const [newsData, setNewsData] = useState({});
  const [selectedNews, setSelectedNews] = useState();
  const [newsCategory, setNewsCategory] = useState("Business");
  const [videoModal, setVideoModal] = useState(false);
  const [indexValue, setIndexValue] = useState(2);
  const [oneNews, setOneNews] = useState();
  const [randomNews, setRandomNews] = useState();
  const handleCheckboxChange12 = (ele) => {
    setSelectedNews(ele);
  };

  const handleCheckboxChange = () => {
    setIsBoth(true);
    setIsDark(true);
    setIsGradient(false);
    setIsRandomColor(false);
  };

  const getRandomQuestion = () => {
    const questions = [
      "The Basics of Quantum Physics Explained",
      "Understanding the Human Digestive System",
      "How the Internet Works: A Simple Guide",
      "Introduction to Machine Learning",
      "The History of Ancient Rome",
      "The Science Behind Climate Change",
      "Introduction to the Solar System",
      "How to Write an Effective Essay",
      "Understanding the Stock Market",
      "The Fundamentals of Algebra",
      "The Water Cycle Explained",
      "A Beginner’s Guide to Coding",
      "The French Revolution: A Brief Overview",
      "How Photosynthesis Works",
      "Introduction to World Religions",
      "The Life Cycle of a Star",
      "Understanding Artificial Intelligence",
      "How Does DNA Work?",
      "Introduction to Financial Literacy",
      "The History of the Internet",
      "How the Immune System Protects You",
      "The Basics of Electricity",
      "Exploring the Human Brain",
      "What is Cryptocurrency?",
      "Understanding Probability and Statistics",
      "How to Learn a New Language Fast",
      "The Structure of the Earth",
      "What is the Theory of Evolution?",
      "Introduction to Cybersecurity",
      "How Planes Fly: The Physics of Aviation",
      "The Causes of World War I",
      "Understanding Chemical Reactions",
      "How to Create a Budget That Works",
      "The Basics of Astronomy",
      "Introduction to Political Science",
      "How Do Vaccines Work?",
      "Understanding Renewable Energy",
      "The Anatomy of the Human Heart",
      "The History of Mathematics",
      "Introduction to Blockchain Technology",
      "The Life of Plants: An Overview",
      "How to Improve Your Memory",
      "Understanding the Laws of Motion",
      "The Basics of Digital Marketing",
      "Introduction to Public Speaking",
      "How to Study Effectively",
      "Understanding Ocean Currents",
      "The History of Ancient Egypt",
      "Introduction to Psychology",
      "The Basics of Graphic Design",
      "How to Build Good Habits",
      "Understanding Global Warming",
      "The Fundamentals of Trigonometry",
      "The Science of Happiness",
      "Introduction to Data Science",
      "How to Develop Critical Thinking Skills",
      "Understanding the Human Skeletal System",
      "The History of the Renaissance",
      "Introduction to Organic Chemistry",
      "The Basics of Video Editing",
      "How the Nervous System Works",
      "Understanding the Fundamentals of Music Theory",
      "The History of the Industrial Revolution",
      "Introduction to Environmental Science",
      "How to Conduct Effective Research",
      "Understanding the Periodic Table",
      "The Basics of 3D Printing",
      "Introduction to Ethical Hacking",
      "How to Write a Research Paper",
      "Understanding the Human Respiratory System",
      "The History of World War II",
      "Introduction to Sociology",
      "The Basics of Sound Waves",
      "How to Improve Your Public Speaking Skills",
      "Understanding Genetic Engineering",
      "The Fundamentals of Calculus",
      "The Science of Sleep",
      "Introduction to Space Exploration",
      "How to Prepare for Exams Effectively",
      "Understanding Light and Optics",
      "The History of the Cold War",
      "Introduction to Microbiology",
      "How to Create a Business Plan",
      "Understanding Earthquakes",
      "The Basics of Project Management",
      "Introduction to Machine Learning Algorithms",
      "How to Set and Achieve Goals",
      "Understanding Ecosystems",
      "The History of the American Civil War",
      "Introduction to Robotics",
      "The Basics of Human Anatomy",
      "How to Build a Website from Scratch",
      "Understanding the Solar System",
      "The Science Behind Vaccines",
      "Introduction to Web Development",
      "How to Excel in Math",
      "Understanding Nutrition and Diet",
      "The History of Computers",
      "Introduction to International Relations",
      "The Basics of Electrical Circuits",
      "How to Develop Time Management Skills",
      "Understanding Black Holes",
      "The History of Ancient Greece",
      "Introduction to Statistics",
      "How to Improve Your Writing Skills",
      "Understanding the Water Cycle",
      "The Fundamentals of Economics",
      "The Science of Climate Change",
      "Introduction to Virtual Reality",
      "How to Be More Productive",
      "Understanding the Immune Response",
      "The History of the Space Race",
      "Introduction to Biology",
      "The Basics of Investing",
      "How to Develop Problem-Solving Skills",
      "Understanding Human Evolution",
      "The History of Art Movements",
      "Introduction to Artificial Neural Networks",
      "The Science of Exercise and Fitness",
      "How to Create Effective Presentations",
      "Understanding Cellular Respiration",
      "The History of the French Revolution",
      "Introduction to Genetic Engineering",
      "The Basics of Human Geography",
      "How to Plan a Career Path",
      "Understanding the Laws of Thermodynamics",
      "The History of Ancient China",
      "Introduction to Entrepreneurship",
      "The Science of Sound",
      "How to Stay Focused While Studying",
      "Understanding Marine Biology",
      "The Basics of Marketing Strategies",
      "Introduction to Philosophy",
      "How to Develop Leadership Skills",
      "Understanding Human Rights",
      "The History of the Roman Empire",
      "Introduction to Social Media Marketing",
      "The Science of Light",
      "How to Overcome Procrastination",
      "Understanding the Earth's Atmosphere",
      "The History of the Scientific Revolution",
      "Introduction to Nanotechnology",
      "The Basics of Creative Writing",
      "How to Communicate Effectively",
      "Understanding Ecosystem Dynamics",
      "The History of Ancient India",
      "Introduction to Game Design",
      "The Science of Nutrition",
      "How to Develop Emotional Intelligence",
      "Understanding the Structure of Atoms",
      "The History of Space Exploration",
      "Introduction to Web Security",
      "The Basics of Financial Planning",
      "How to Learn Faster",
      "Understanding Quantum Mechanics",
      "The History of the Middle Ages",
      "Introduction to Astrobiology",
      "The Science of Motivation",
      "How to Build a Personal Brand",
      "Understanding the Greenhouse Effect",
      "The History of the Atomic Bomb",
      "Introduction to Cryptography",
      "The Basics of User Experience Design",
      "How to Think Critically",
      "Understanding Social Psychology",
      "The History of the Byzantine Empire",
      "Introduction to Geology",
      "The Science of Stress Management",
      "How to Build a Mobile App",
      "Understanding the Structure of DNA",
      "The History of the Silk Road",
      "Introduction to Behavioral Economics",
      "The Basics of Cloud Computing",
      "How to Overcome Test Anxiety",
      "Understanding Plate Tectonics",
      "The History of Medieval Europe",
      "Introduction to Renewable Energy Technologies",
      "The Science of Cognitive Biases",
      "How to Develop a Growth Mindset",
      "Understanding the Human Circulatory System",
      "The History of the Renaissance Art",
      "Introduction to Artificial Intelligence Ethics",
      "The Basics of Computer Networks",
      "How to Improve Your Logical Reasoning Skills",
      "Understanding the Physics of Gravity",
      "The History of Modern Medicine",
      "Introduction to Environmental Sustainability",
      "The Science of Human Behavior",
      "How to Build Confidence",
      "Understanding the Process of Evolution",
      "The History of Space Technology",
      "Introduction to Astrophysics",
      "The Basics of Data Analysis",
      "How to Cultivate Creativity",
      "Understanding Chemical Bonding",
      "The History of the Industrial Age",
      "Introduction to Digital Art",
      "The Science of Learning",
      "How to Create a Successful YouTube Channel",
      "Understanding the Anatomy of Plants",
    ];

    const randomIndex = Math.floor(Math.random() * questions.length);
    return questions[randomIndex];
  };

  const fetchNewsByCategory = async (newsCategory) => {
    try {
      const response = await fetch(
        `https://backend.whalesai.com/api/v1/admin/news/get/news/${newsCategory}`
      );
      const data = await response.json();
      console.log("category wise data::::::::", data);
      setRandomNews(data);
    } catch (error) {
      console.error("Error fetching news by category:", error);
    }
  };
  useEffect(() => {
    fetchNewsByCategory(newsCategory);
  }, [newsCategory]);

  useEffect(() => {
    setRandomQuestion(getRandomQuestion());
  }, []);

  const [isGenerateButtonDisabled, setIsGenerateButtonDisabled] =
    useState(false);

  const { AIuser, userRefetch, setUserRefetch, isBack } =
    useContext(UserAuthContext);
  const [inputText, setInputText] = useState("");
  const [enableOwnScript, setEnableOwnScript] = useState(false);
  const [generatedText, setGeneratedText] = useState(
    "Artificial Intelligence (AI) is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is the ability of a computer or machine to think and learn like a human. It is a form of intelligence that is based on algorithms and data, rather than on human intelligence.\n\n\nAI is used in a variety of applications, from self-driving cars to medical diagnosis. AI is used to automate tasks that would otherwise require human intelligence. For example, AI can be used to analyze large amounts of data and make decisions based on the data. AI can also be used to recognize patterns in data and make predictions about future events.\n\n\nAI can also be used to create virtual assistants that can respond to user queries and provide helpful information. AI is also being used to create robots that can interact with humans in a more natural way. These robots can be used to perform tasks such as cleaning, cooking, and providing companionship.\n\n\nAI is also being used to create virtual reality experiences that can be used for entertainment or educational purposes. AI is also being used to create autonomous vehicles that can drive themselves. These vehicles are being developed to reduce the number of accidents on the road and to make transportation more efficient.\n\n\nAI is also being used to create autonomous drones that can be used for surveillance or delivery purposes. AI is also being used to create intelligent machines that can understand natural language and respond to user queries. These machines can be used to provide customer service or to provide information about products and services.\n\n\nAI is also being used to create intelligent robots that can interact with humans in a more natural way. AI is a rapidly growing field of technology that is revolutionizing the way we interact with the world. AI is being used in a variety of applications, from self-driving cars to medical diagnosis. AI is also being used to create autonomous vehicles, robots, and intelligent machines that can understand natural language and respond to user queries. AI is a powerful tool that is being used to create a more efficient and safer world."
  );

  const [isLoading, setIsLoading] = useState(false);
  const [value, setValue] = useState(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (location?.state?.back && isBack) {
      const backText = location?.state?.text;
      const backInput = location?.state?.inputText;
      setInputText(backInput);
      setGeneratedText(backText);
    }
  }, [location, isBack]);

  useEffect(() => {
    if (location.state !== null) {
      setInputText(location.state.requestQues);
      setGeneratedText(location.state.response);
    }
  }, [location.state]);

  function generateRandomAlphanumeric() {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 8; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  const handleSubmitCredits = async (e) => {
    const deductedCredits = AIuser.credits - 100;
    await axios
      .put(
        "https://backend.whalesai.com/api/dashboard/user_signup-signin/update-credits",
        { email: AIuser?.email, credits: deductedCredits },
        {
          headers: {
            authorization: `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setUserRefetch(!userRefetch);
        }
      })
      .catch((err) => {
      });
  };

  const generateNews = async () => {
    fetchNewsByCategory(newsCategory);
    setOneNews("");
    setIsLoading(true);
    setIsGenerateButtonDisabled(true);
    const response = await axios.get(
      `https://backend.whalesai.com/api/v1/news/get`,
      {
        params: { category: newsCategory, event },
      }
    );
    const data = await response.data.articles;
    if (response.data.statusCode === 404) {
      return swal({
        icon: "warning",
        title: "Something Went Wrong!",
        button: "Close",
        className: "modal_class_success",
      });
    }
    setNewsData(data);
    setIsGenerateButtonDisabled(false);
    setIsLoading(false);
    setQuery("");
  };
  const DisableBtn = async () => {
    fetchNewsByCategory(newsCategory);
    setOneNews("");
    const wrapper = document.createElement("div");
    wrapper.innerHTML = `<p></p> <p class="text-danger">Warning: Please Select News item first!</p> `;

    return swal({
      content: wrapper,
      icon: "error",
      buttons: "Ok",
      className: "modal_class_success",
    });
  };

  const handleTextChange = (e) => {
    const text = e.target.value;
    const wordCount = text.split(/\s+/).length;
    setInputText(text);
    setGeneratedText("");

    if (enableOwnScript && wordCount > 600) {
      setIsGenerateButtonDisabled(true);
    } else {
      setIsGenerateButtonDisabled(false);
    }
  };

  const handleTrigger = () => {
    setInputText("");
    setEnableOwnScript(false);
  };

  const handleTabChange = async (event, newValue) => {
    setValue(newValue);
    setIsLoading(true);
    const response = await axios.get(
      `https://backend.whalesai.com/api/v1/news/get`,
      {
        params: { category: newValue },
      }
    );
    const data = await response.data.articles;
    if (response.data.statusCode === 404) {
      return swal({
        icon: "warning",
        title: "Something Went Wrong!",
        button: "Close",
        className: "modal_class_success",
      });
    }
    setNewsData(data);
    setIsLoading(false);
  };
  const handleCheckedNews = (item) => {
    setOneNews(item);
  };

  const handleChecked = async () => {
    if (AIuser.credits > 100) {
      setTimeout(() => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `<p></p> <p class="text-white">we are generating the video for you. We will send the video links to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

        swal({
          content: wrapper,
          icon: "success",
          button: "Close",
          className: "modal_class_success",
        }).then(() => {
          swal({
            icon: "success",
            button: {
              text: "Refreshing the page for you",
              className: "bg-danger",
            },
            className: "modal_class_success",
            closeOnClickOutside: false, // Prevent closing by clicking outside
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000); // Adjust the delay as needed
        });
      }, 1000);

      setGeneratedText("");
      setIsLoading(true);
      handleSubmitCredits();

      const bodyContent = {
        email: AIuser?.email,
        userId: AIuser?._id,
        isDark: isDark,
        isGradient: isGradient,
        isRandomColor: isRandomColor,
        transactionId: generateRandomAlphanumeric(),
        description: oneNews?.summary,
        question: oneNews?.title,
        url: "",
      };

      try {
        const response = await fetch(
          `https://backend.whalesai.com/api/v1/img/generate-news-video?dimension=all`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyContent),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to generate video");
        }

        const data = await response.json();
        if (data.message === "Video created successfully") {
          alert("video created successfully");

          setIsLoading(false);
        } else {
          throw new Error("Failed to generate video");
        }
      } catch (error) {
      }
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/ver2/purchase");
        }
      });
    }
  };

  const handleCheckedComic = async () => {
    if (AIuser.credits > 120) {
      setTimeout(() => {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = `<p></p> <p class="text-white">we are generating the video for you. We will send the video links to <span class="text-warning">${AIuser?.email}</span>. It might take up to 10 mins. <br/> You can generate more contents while waiting for our email.</p> `;

        swal({
          content: wrapper,
          icon: "success",
          button: "Close",
          className: "modal_class_success",
        }).then(() => {
          swal({
            icon: "success",
            button: {
              text: "Refreshing the page for you",
              className: "bg-danger",
            },
            className: "modal_class_success",
            closeOnClickOutside: false, // Prevent closing by clicking outside
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000); // Adjust the delay as needed
        });
      }, 1000);

      setGeneratedText("");
      setIsLoading(true);
      handleSubmitCredits();

      const bodyContent = {
        email: AIuser?.email,
        userId: AIuser?._id,
        isDark: isDark,
        isGradient: isGradient,
        isRandomColor: isRandomColor,
        transactionId: generateRandomAlphanumeric(),
        description: oneNews?.comicSummary,
        question: oneNews?.title,
      };

      try {
        const response = await fetch(
          `https://backend.whalesai.com/api/v1/img/generate-comic-news-video?dimension=all`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(bodyContent),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to generate video");
        }

        const data = await response.json();
        if (data.message === "Video created successfully") {
          alert("video created successfully");

          setIsLoading(false);
        } else {
          throw new Error("Failed to generate video");
        }
      } catch (error) {
      }
    } else {
      swal({
        text: "You don't have enough credits! Please buy credits to continue.",

        icon: "error",
        buttons: "Ok",
        className: "modal_class_success",
      }).then((value) => {
        if (value) {
          navigate("/purchase");
        }
      });
    }
  };

  const newsCategories = [
    { value: "Business", text: "Business" },
    { value: "Science", text: "Science" },
    { value: "Singapore", text: "Singapore" },
    { value: "Technology", text: "Technology" },
    { value: "World", text: "World" },
  ];

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const response = await axios.get(
        `https://backend.whalesai.com/api/v1/news/get`,
        {
          params: { category: newsCategory },
        }
      );
      const data = await response.data.articles;
      if (response.data.statusCode === 404) {
        return swal({
          icon: "warning",
          title: "Something Went Wrong!",
          button: "Close",
          className: "modal_class_success",
        });
      }
      setNewsData(data);
      setIsLoading(false);
    })();
  }, []);

  {
    /* Will Implement later: Start */
  }
  const [selectedOption, setSelectedOption] = useState("");
  // const [isDark, setIsDark] = useState(false);
  const [isGradient, setIsGradient] = useState(false);
  const [isRandomColor, setIsRandomColor] = useState(false);
  const [isBoth, setIsBoth] = useState(false);
  const [videoPosition, setVideoPosition] = useState(0);

  const handleCheckGradient = () => {
    setIsGradient(true);
    setIsRandomColor(false);
    setIsBoth(false);
    // setIsDark(false);
    setVideoPosition(3);
  };

  const handleCheckRandomColor = () => {
    setIsRandomColor(true);
    setIsBoth(false);
    // setIsDark(false);
    setIsGradient(false);
    setVideoPosition(4);
  };

  const handleCheckBothGR = () => {
    setIsBoth(true);
    // setIsDark(false);
    setIsGradient(false);
    setIsRandomColor(false);
    setVideoPosition(2);
  };

  const handleOptionChange = (e) => {
    const value = e?.target?.value;
    setSelectedOption(value);

    switch (value) {
      case "Gradient":
        handleCheckGradient();
        break;
      case "Random Colors":
        handleCheckRandomColor();
        break;
      case "Random Color Gradients":
        handleCheckBothGR();
        break;
      case "Classic Black and White":
        handleCheckboxChange();
        break;
      default:
        setVideoPosition(0);
        break;
    }
  };

  const color = { isDark, isGradient, isRandomColor, isBoth };

  {
    /* Will Implement later: End */
  }

  return (
    <Fragment>
      <PageHeading_V2
        title={"NEWS VIDEO AI"}
        description={
          "The News Video AI can generate text-based videos featuring the latest news."
        }
      />
      <SampleTextVideo
        videoModal={videoModal}
        setVideoModal={setVideoModal}
        indexValue={2}
      />
      <div className="img-ai-container container pb-5">
        <div
          style={{
            maxWidth: "872px",
            paddingInline: "12px",
            marginInline: "auto",
          }}
        >
          <div className="position-relative">
            {" "}
            {/* Adjust height as needed */}
            <IconButton
              style={{
                color: "#ffa21f",
                position: "absolute",
                // top: "calc(0px - 100px)",
                top:
                  window.innerWidth < 576
                    ? "calc(0px - 70px)"
                    : "calc(0px - 100px)",
                left: "50%", // Horizontal center
                transform: "translateX(-50%)", // Ensures it's centered from its width
              }}
              onClick={() => setVideoModal(true)}
              title="See sample video"
            >
              <InfoIcon />
            </IconButton>
          </div>
          <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm">
            <div className="d-flex ">
              <CreditsButton_V2 />
            </div>
          </div>
          <p
            style={{ fontSize: "8px" }}
            className="text-white text-center mt-2 mb-0 centralize-credits-btn-sm"
          >
            100 Credits per video
          </p>
        </div>

        <div className="container pt-3">
          <div style={{ maxWidth: "850px" }} className="mx-auto">
            <div>
              <div className="selectDiv">
                <div className="postais">
                  <div className="d-flex justify-content-center align-items-center">
                    <select
                      onChange={(e) => setNewsCategory(e.target.value)}
                      value={newsCategory}
                      className="selector"
                      id=""
                    >
                      {newsCategories.map((cat) => (
                        <option
                          key={cat.value}
                          className="textai-option"
                          value={cat.value}
                        >
                          {cat.text}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex justify-content-center align-items-center">
                    <select
                      onChange={(e) => setEvent(e.target.value)}
                      value={event}
                      className="selector mt-3"
                      id=""
                    >
                      <option className="textai-option" value="Day">
                        Today
                      </option>
                      <option className="textai-option" value="Week">
                        This Week
                      </option>
                      <option className="textai-option" value="Month">
                        This Month
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-4 text-center">
              {isGenerateButtonDisabled ? (
                <button
                  onClick={DisableBtn}
                  // onClick={fetchNewsByCategory(newsCategory)}
                  className="generate-buttonDisabled rounded"
                >
                  Retrieve News
                </button>
              ) : (
                <button
                  onClick={generateNews}
                  // onClick={fetchNewsByCategory(newsCategory)}
                  className="generate-button rounded"
                  disabled={isGenerateButtonDisabled}
                >
                  Retrieve News
                </button>
              )}
            </div>

            {isLoading && (
              <div className="text-center my-3">
                <div class="spinner-border text-light" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
            )}

            {/* result data  */}
            {!isLoading && !newsData?.length && (
              <p className="text-center fs-5 text-white mt-4">
                No Result Found!
              </p>
            )}

            {
              <div className="mt-5">
                {randomNews?.map((item, i) => (
                  <div
                    key={i}
                    className="d-flex justify-content-start flex-column flex-md-row align-items-start gap-3 mb-4"
                  >
                    <div className="d-flex mx-auto align-items-start gap-2">
                      <input
                        type="checkbox"
                        checked={oneNews?.title == item?.title}
                        onChange={() => handleCheckedNews(item)}
                        style={{ width: "20px", height: "20px" }}
                      />
                    </div>
                    <div style={{ width: "100%" }}>
                      <div>
                        <p className="mb-2 text-md-start text-center text-primary">
                          {item?.title}
                        </p>
                      </div>

                      <p className="text-white text-md-start text-center mt-3 two-line-text">
                        {item?.summary?.split("\n\n")[0].length > 2
                          ? `${item.summary.split("\n\n")[0]}`
                          : item?.summary?.split("\n\n")[0]}
                      </p>
                      <p
                        className="text-md-start text-center"
                        style={{
                          color: "yellow",
                          marginTop: "0px",
                          fontSize: "14px",
                        }}
                      >
                        {item?.createdAt}(SG Time)
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            }

            {newsCategory && (
              <>
                {/* Will Implement later: Start */}

                <div
                  className="d-flex align-items-center justify-content-center text-center mt-4"
                  // onClick={() => {
                  //   Swal.fire({
                  //     title: "Coming Soon !",
                  //     // text: "This feature will be available soon!",
                  //     icon: "info",
                  //     confirmButtonText: "OK",
                  //     background: "#011225",
                  //   });
                  // }}
                  style={{ cursor: "pointer" }} // Add pointer cursor for clickable effect
                >
                  <select
                    className="form-select form-select-sm text-uppercase"
                    value={selectedOption}
                    onChange={handleOptionChange}
                    style={{ width: "220px" }} // Prevent interaction with the select element
                  >
                    <option value="">Please select</option>
                    <option value="Gradient">Gradient</option>
                    <option value="Random Colors">Colors</option>
                    <option value="Random Color Gradients">
                      Color Gradients
                    </option>
                    <option value="Classic Black and White">B & W</option>
                  </select>
                  {videoPosition == 0 ? (
                    " "
                  ) : (
                    <IconButton
                      style={{ color: "#ffa21f" }}
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent the SweetAlert from triggering
                        setModalShow(true);
                      }}
                      title="See sample video"
                      className="mt-0"
                    >
                      <InfoIcon />
                    </IconButton>
                  )}
                </div>

                {/* Will Implement later: End */}

                <div className="mt-4 text-center gap-4">
                  <button
                    onClick={() => {
                      setInputText("");
                      setGeneratedText("");
                      setNewsData({});
                      setIsGenerateButtonDisabled(false);
                      setOneNews({});
                    }}
                    className="clear-button rounded mb-4"
                  >
                    Clear
                  </button>

                  <button
                    onClick={handleChecked}
                    className={`generate-button rounded ${!oneNews ? "bg-secondary" : ""
                      }`}
                    disabled={!oneNews || isLoading}
                  >
                    GENERATE NEWS VIDEO
                  </button>
                </div>
                <div className="mt-3 text-center">
                  <button
                    onClick={handleCheckedComic}
                    className={`generate-button rounded ${!oneNews ? "bg-secondary" : ""
                      }`}
                    disabled={!oneNews || isLoading}
                  >
                    GENERATE COMIC VIDEO
                  </button>
                </div>
              </>
            )}
            <div className="btnvideoDiv"></div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default VideoAiNews_V2;